import { Injectable } from "@angular/core";
import { BreadcrumbEventModel } from "../models/breadcrumb-event.model";
import { filter, map, Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {
    
    private eventSubject: Subject<BreadcrumbEventModel> = new Subject<BreadcrumbEventModel>();

    publish(event: BreadcrumbEventModel): void {
        this.eventSubject.next(event);
    }

    listen(topic: string): Observable<any> {
        return this.eventSubject.asObservable().pipe(
            filter(event => event.topic === topic),
            map(event => event.payload)
        );
    }

}